import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, ToastController } from '@ionic/angular';
import { forkJoin } from 'rxjs';
import { City } from 'src/app/interfaces/api/city';
import { MDStock, MHProduct, Warehouse, Warehouses } from 'src/app/interfaces/api/product';
import { CheckoutItem } from 'src/app/pages/checkout/checkout.page';
import { ProductService } from 'src/app/services/product.service';
import { CartService } from 'src/app/services/cart.service';
import { encodeQueryParam, transformWeight } from 'src/helpers';

@Component({
  selector: 'app-modal-select-warehouse',
  templateUrl: './modal-select-warehouse.component.html',
  styleUrls: ['./modal-select-warehouse.component.scss'],
})
export class ModalSelectWarehouseComponent implements OnInit {
  @Input() mode: 'checkout' | 'cart';
  @Input() detailProduk: MHProduct;

  @Input() initialWarehouse: MDStock;
  @Input() initialCity: City | undefined;
  @Input() availableCities: City[];
  @Input() stockWarehouse: MDStock[];

  @Input() qty: number;
  @Input() isQtyChange: boolean;
  @Input() dontHaveStock: boolean;

  warehouseList: Warehouses;
  isLoading = true;

  selectedCity: City;
  selectedCityWarehouses: Warehouse[];
  weight: string;

  constructor(
    private modalController: ModalController,
    private productService: ProductService,
    private router: Router,
    private toastController: ToastController,
    private cartService: CartService,
  ) {}

  ngOnInit() {
    this.weight = transformWeight(this.detailProduk.weight);
    this.loadData(null);
  }

  async loadData(event: any) {
    this.isLoading = true;

    const warehouseReq = this.productService.getWarehouseList();

    forkJoin([warehouseReq]).subscribe({
      next: async ([warehouseRes]) => {
        const warehouses = { ...warehouseRes.warehouses };

        for (const MdWarehouse of this.stockWarehouse) {
          const warehouseInCity = warehouses[MdWarehouse.city_name];

          if (!warehouseInCity) {
            continue;
          }

          const selectedCity = [...warehouseInCity];
          const selectedWarehouseIndex = selectedCity.findIndex(item => item.name === MdWarehouse.warehouse_name);
          const selectedWarehouse = selectedCity[selectedWarehouseIndex];

          // replace old data
          selectedCity.splice(selectedWarehouseIndex, 1);

          // create warehouse data with updated stock
          const newWarehouse: Warehouse = { stock: MdWarehouse.ready_stock, ...selectedWarehouse };

          // push new data
          selectedCity.push(newWarehouse);

          // update warehouselist on selected city
          warehouses[MdWarehouse.city_name] = selectedCity;
        }

        this.warehouseList = warehouses;
      },
      complete: () => {
        this.isLoading = false;
        if (this.initialCity !== undefined) {
          this.selectedCity = this.initialCity;
          this.selectedCityWarehouses = this.warehouseList[this.selectedCity.name];
        }
        event?.target?.complete();
      },
    });
  }

  async cancel() {
    await this.modalController.dismiss();
  }

  resetCity() {
    this.selectedCity = undefined;
  }

  selectCity(city: City) {
    this.selectedCity = city;
    this.selectedCityWarehouses = this.warehouseList[this.selectedCity?.name];
    this.initialWarehouse = this.stockWarehouse.find(w => w.id_mh_warehouse === this.selectedCityWarehouses[0].id);
  }

  selectCabang(warehouse: Warehouse) {
    this.initialWarehouse = this.stockWarehouse.find(w => w.id_mh_warehouse === warehouse.id);
  }

  toNumber(str: string) {
    return Number(str);
  }

  addDecQtyHandler(event) {
    this.qty = event.currentQty ?? 0;
  }

  changeQuantityHandler(event) {
    this.qty = event.currentQty ?? 0;
  }

  toggleIsChangeQtyHandler(event) {
    this.isQtyChange = event.isQtyChange;
  }

  async onCheckout() {
    if (this.qty <= 0) {
      this.presentToast('Masukan jumlah produk ke cart lebih dari 0');
      return;
    }

    if (this.initialWarehouse.ready_stock < this.qty) {
      this.presentToast('Stok kurang silahkan pilih unit lain');
      return false;
    }

    const checkoutItems: CheckoutItem[] = [];

    checkoutItems.push({
      id_mh_warehouse: this.initialWarehouse.id_mh_warehouse,
      cartId: null,
      product: { ...this.detailProduk },
      qty: this.qty,
    });

    const queryParams = {
      checkoutItems: encodeQueryParam(checkoutItems),
    };

    this.router.navigate(['/checkout'], { queryParams });

    // this.router.navigate(['/checkout'], {
    //   state: {
    //     data: {
    //       checkoutItems: JSON.stringify(checkoutItems),
    //     },
    //   },
    // });
    this.cancel();
  }

  async onAddToCart() {
    if (this.qty <= 0) {
      this.presentToast('Masukan jumlah produk ke cart lebih dari 0');
      return;
    }

    if (this.qty > this.initialWarehouse.ready_stock) {
      this.presentToast('Stok kurang silahkan pilih lokasi warehouse lain', 1500, 'danger');
      return;
    }

    this.cartService.getCartCollection().subscribe({
      next: val => {
        const exist =
          val.carts.findIndex(
            cart =>
              cart.id_mh_product === this.detailProduk.id &&
              cart.id_mh_warehouse === this.initialWarehouse.id_mh_warehouse,
          ) !== -1;

        if (!exist) {
          this.proceedAddToCart();
        } else {
          this.proceedAddQtyToCart();
        }
      },
    });
  }

  proceedAddToCart() {
    this.cartService.addToCart(this.detailProduk.id, this.qty, this.initialWarehouse.id_mh_warehouse).subscribe({
      next: addToCartRes => {
        this.presentToast(addToCartRes.message);
        this.modalController.dismiss(null, 'addedToCart');
      },
    });
  }

  proceedAddQtyToCart() {
    this.cartService
      .addToCartAddMinus(this.detailProduk.id, this.qty, this.initialWarehouse.id_mh_warehouse)
      .subscribe({
        next: addToCartRes => {
          this.presentToast(addToCartRes.message);
          this.modalController.dismiss(null, 'addedToCart');
        },
      });
  }

  protected async presentToast(message: string, duration: number = 1000, color?: string): Promise<void> {
    const toast = await this.toastController.create({
      message,
      duration,
      mode: 'ios',
      color,
    });
    return await toast.present();
  }
}
